'use es6';

import { ensureFn, once } from './helpers';
import { parseExperiments } from './parsers';
import { resolveTreatments, createAsyncResolver } from './utils';
import { getCacheKeys, saveOverridesToCache } from './overrides';
import { getAsyncNetworkAdapter, wrapNetworkAdapterWithMeta } from './network';
import { DEBUG_MESSAGES } from '../messages';

function removeSchemaEntriesWithEmptyIdentifiers(logDebug, schema) {
  return Object.keys(schema).reduce((acc, key) => {
    const treatment = schema[key];

    if (treatment.identifier === null || treatment.identifier === undefined) {
      ensureFn(logDebug)(DEBUG_MESSAGES.treatmentIgnored(key), 'createTreatmentsResolver');
      return acc;
    }

    return Object.assign({}, acc, {
      [key]: treatment
    });
  }, {});
}

export function createTreatmentsResolver({
  apiDomain,
  asyncStore,
  ceid,
  http,
  onError,
  quickFetch,
  quickFetchLabel,
  search,
  treatments,
  experiments,
  identifiers,
  timeout,
  logDebug,
  useCacheOnly
} = {}) {
  // Removes all the schema entries that have empty identifiers
  // As they should not be sent to the server
  const schema = removeSchemaEntriesWithEmptyIdentifiers(logDebug, // if experiments (parameter) is present, parses them into a treatments schema
  // otherwise fallback to treatments, that if also not provided by default is an empty object
  experiments ? parseExperiments({
    experiments,
    identifiers
  }) : treatments);
  const cacheKeys = getCacheKeys({
    schema
  });
  const networkAdapter = getAsyncNetworkAdapter({
    apiDomain,
    ceid,
    http,
    quickFetch,
    quickFetchLabel,
    schema,
    identifiers,
    timeout
  });
  const getAsyncData = wrapNetworkAdapterWithMeta({
    networkAdapter,
    asyncStore,
    cacheKeys,
    ceid,
    search,
    schema,
    onError,
    useCacheOnly,
    logDebug
  });
  const asyncTreatmentsResolver = createAsyncResolver({
    getAsyncData,
    resolve: once(resolveTreatments),
    onError
  });
  const updateTreatmentsToCache = once(resolvedTreatments => saveOverridesToCache({
    schema,
    treatments: resolvedTreatments,
    asyncStore,
    onError
  }));
  return {
    resolveTreatments: callback => {
      asyncTreatmentsResolver(resolvedTreatments => {
        updateTreatmentsToCache(resolvedTreatments);
        ensureFn(callback)(resolvedTreatments);
      });
    }
  };
}